export default "__VITE_ASSET__tIDUn2rChPOYQ1wn0fDMzw__"